import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import classnames from 'classnames';
import {
  VisibilityGroup,
  CreateVisibilityGroupFormData,
  Dict,
} from '../../../../core';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../../api';
import { VisibilityGroupInput } from '../../../../components/form-group';
import { IEntity, IEntityVisibility } from '.';

const CreateForm: React.FunctionComponent<{
  onSubmit: (data?: IEntity) => void;
  isSubmitting?: boolean;
  error?: string;
  entity?: IEntity;
  onCancel?: () => void;
}> = (props) => {
  const [entity, setEntity] = useState(props.entity);
  React.useEffect(() => {
    setEntity(props.entity);
  }, [props.entity]);

  const { data } = useDataLoader<VisibilityGroup[]>(() =>
    api.visibilityGroup.loadVisibilityGroup()
  );

  const { handleSubmit } = useForm<CreateVisibilityGroupFormData>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onUpdateEntity = () => {
    props.onSubmit(entity);
  };

  const renderEntity = () => {
    return (
      <>
        {entity?.vg?.map((item: IEntityVisibility) => {
          return (
            <div className="col-12">
              <div className="form-group font-weight-semibold">
                <label className="font-sm text-uppercase">{item.label}</label>
                <VisibilityGroupInput
                  defaultValue={item.value}
                  data={data}
                  onChange={(groups: VisibilityGroup[]) => {
                    setEntity({
                      ...entity,
                      vg: entity?.vg?.map((g: IEntityVisibility) => {
                        return {
                          ...g,
                          value:
                            g.key === item.key
                              ? (groups?.map((gg) => gg._id) as string[]) || []
                              : g.value,
                        };
                      }),
                    });
                  }}
                />
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const renderEntiryTab = () => {
    return <div className="row gutter-10">{renderEntity()}</div>;
  };

  return (
    <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
      <div className="text-right d-md-none">
        <i className="icon-close"></i>
      </div>
      <div className="p-4">
        <>
          <h4 className="mb-3 font-weight-semibold">{entity?.label}</h4>

          <div>{renderEntiryTab()}</div>
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-4 text-right pt-3">
              <button
                className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                onClick={props.onCancel}
              >
                Cancel
              </button>

              <button
                className={classnames({
                  'btn btn-primary py-2 font-weight-semibold font-normal px-4': true,
                })}
                onClick={handleSubmit(onUpdateEntity)}
                disabled={props.isSubmitting}
              >
                Update
              </button>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default CreateForm;
